import { render, staticRenderFns } from "./NoVatForm.vue?vue&type=template&id=24ecd690&scoped=true&"
import script from "./NoVatForm.vue?vue&type=script&lang=ts&"
export * from "./NoVatForm.vue?vue&type=script&lang=ts&"
import style0 from "./NoVatForm.vue?vue&type=style&index=0&id=24ecd690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ecd690",
  null
  
)

export default component.exports